import React from 'react';

interface SigningErrorProps {
  message: string;
  canRetry: boolean;
  onRetry: () => void;
}

const SigningError: React.FC<SigningErrorProps> = ({
  message,
  canRetry,
  onRetry,
}) => {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 24px',
      }}
    >
      <div
        style={{
          width: '72px',
          height: '72px',
          borderRadius: '50%',
          backgroundColor: '#fef2f2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '24px',
        }}
      >
        <svg
          width="36"
          height="36"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ef4444"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <p
        style={{
          margin: '0 0 24px',
          fontSize: '15px',
          color: '#6b7280',
          textAlign: 'center',
          lineHeight: '22px',
          maxWidth: '280px',
        }}
      >
        {message}
      </p>
      {canRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: '14px 32px',
            borderRadius: '12px',
            border: 'none',
            fontSize: '15px',
            fontWeight: 600,
            color: '#ffffff',
            backgroundColor: '#6366f1',
            cursor: 'pointer',
            minHeight: '48px',
          }}
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export default SigningError;
